import { httpResource } from '@angular/common/http';
import { computed, Injectable, Signal } from '@angular/core';
import {
  publicEliminationSchema,
  publicOperationSchema,
  type PublicElimination,
  type PublicOperation,
} from '@killer-party/contracts';
import { environment } from '../../environments/environment';
import { field } from './http-parse';
import { readResource, ReadResource } from './read-resource';

type PublicId = () => string | undefined;

// Page publique d'une operation (TD-016) et eliminations d'une operation terminee (TD-021).
@Injectable({ providedIn: 'root' })
export class PublicOperationService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/operations`;

  operation(publicId: PublicId): ReadResource<PublicOperation> {
    const id = computed(publicId);
    return readResource(
      httpResource(() => this.url(id), { parse: field('operation', publicOperationSchema) }),
    );
  }

  // 409 OPERATION_NOT_COMPLETE tant que l'operation n'est pas terminee.
  eliminations(publicId: PublicId): ReadResource<PublicElimination[]> {
    const id = computed(publicId);
    return readResource(
      httpResource(() => this.url(id, 'eliminations'), {
        parse: field('eliminations', publicEliminationSchema.array()),
      }),
    );
  }

  // L'identifiant passe par un computed : une source rechargee (la mission, toutes les
  // quelques secondes) qui garde le meme identifiant ne relance pas la requete. Sinon
  // httpResource repart de zero et la page clignote le temps de la relecture.
  private url(publicId: Signal<string | undefined>, path?: string): string | undefined {
    const id = publicId();
    return id === undefined
      ? undefined
      : [this.baseUrl, encodeURIComponent(id), path].filter(Boolean).join('/');
  }
}
